import { SvgStyled } from '../../components/Global/Atomics/SvgStyled';

const SettingsNova = (props) => {
    const width = props.width ? props.width + 'px' : '24px';
    const height = props.height ? props.height + 'px' : '27px';

    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 24 27"
            fill={props.fill ? props.fill : 'none'}
            customColor={props.customColor}
            width={width}
            height={height}>
            <path d="M24 15.5932V11.0198H20.2783C20.0718 10.0983 19.744 9.23744 19.3129 8.4438L21.9479 5.52485L19.0276 2.28978L16.3926 5.20874C15.6762 4.73121 14.8991 4.36802 14.0673 4.13935V0.00976562H9.93878V4.13262C9.10701 4.3613 8.32988 4.72449 7.61346 5.20201L4.97243 2.28306L2.05211 5.51812L4.68707 8.43708C4.25601 9.23071 3.92816 10.0916 3.72173 11.013H0V15.5865H3.72173C3.92816 16.5079 4.25601 17.3688 4.68707 18.1625L2.05211 21.0814L4.97243 24.3165L7.60739 21.3975C8.3238 21.875 9.10094 22.2382 9.93271 22.4669V26.5898H14.0612V22.4669C14.893 22.2382 15.6701 21.875 16.3865 21.3975L19.0215 24.3165L21.9418 21.0814L19.3069 18.1625C19.7379 17.3688 20.0658 16.5079 20.2722 15.5865H23.9939L24 15.5932ZM12.003 18.1894C9.5745 18.1894 7.59524 15.9968 7.59524 13.3065C7.59524 10.6162 9.5745 8.42363 12.003 8.42363C14.4316 8.42363 16.4108 10.6162 16.4108 13.3065C16.4108 15.9968 14.4316 18.1894 12.003 18.1894Z" />
        </SvgStyled>
    );
};

export default SettingsNova;
